import { toFriendlyRecoveryCertificateId } from 'helpers/string'
import { AdminSearchQuery_adminSearch_results_RecoveryCertificate } from '../__generated__/AdminSearchQuery'
import { RecoveryCertificateQuery_recoveryCertificates } from './__generated__/RecoveryCertificateQuery'

export const RecoveryCertificateLink = ({
  recoveryCertificate,
  orderId,
  children,
  ...props
}: {
  recoveryCertificate?:
    | RecoveryCertificateQuery_recoveryCertificates
    | AdminSearchQuery_adminSearch_results_RecoveryCertificate
  orderId?: RecoveryCertificateQuery_recoveryCertificates['orderId']
  children?: React.ReactNode
  props: React.HTMLAttributes<HTMLAnchorElement>
}) => {
  return (
    <a href={`/dashboard/recovery-certificate/${orderId || recoveryCertificate.orderId}`} target="_blank" {...props}>
      {children || toFriendlyRecoveryCertificateId(orderId || recoveryCertificate.orderId)}
    </a>
  )
}

export default RecoveryCertificateLink
